import { FeatureFlagNames } from 'common/open-features'
import { useCheckFlag } from 'common/open-features/hooks'
import isEqual from 'lodash/isEqual'
import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAssetCategoriesAuth } from 'store/settings/assetCategory/actions'
import { selectAssetCategoryList } from 'store/settings/assetCategory/selectors'

export const useGetAssetCategory = () => {
  const dispatch = useDispatch()
  const { isEnable: enableAssetCategoryJudgmentAI } = useCheckFlag(FeatureFlagNames.AssetCategoryJudgmentAI)
  const { assetCategories: assetCategoryList } = useSelector(selectAssetCategoryList, isEqual)

  const getAssetCategoryList = useCallback(() => {
    dispatch(fetchAssetCategoriesAuth({ sort: ['code'] }))
  }, [])

  useEffect(() => {
    enableAssetCategoryJudgmentAI && getAssetCategoryList()
  }, [enableAssetCategoryJudgmentAI])

  return {
    assetCategoryList,
  }
}
